<template>
  <card
    title="לחזור ללקוח היום"
    :linkTo="`/tasks?notCompleted=true&types=${callCustomerTask}&dueDateBefore=${format(addDays(Date(), 1), 'YYYY-MM-DD')}`"
    actionButton="לכל הרשימה"
    :number="number"
    :loading="loading"
    :error="error"
  />
</template>

<script>
import { format, addDays } from 'date-fns';
import { getApi } from '@/api';
import Card from "./Card.vue";

export default {
  data() {
    return {
      number: 0,
      loading: false,
      error: false
    };
  },

  computed: {
    callCustomerTask() {
      let callCustomerTask = Object.values(this.$store.state.entities.taskTypes).find(item => {
        return item.key === 'CALL_CUSTOMER';
      })
      return callCustomerTask ? callCustomerTask._id : null;
    }
  },

  methods: {
    format,
    addDays,
    fetchData() {
      this.loading = true;
      getApi()
        .then(api => {
          let params = {
            dueDateBefore: format(addDays(Date(), 1), 'YYYY-MM-DD'),
            types: this.callCustomerTask,
            notCompleted: true
          };
          return api.get('/tasks', { params })
        })
        .then(({ data }) => {
          this.number = data.totalResults;
        })
        .catch(err => {
          console.log(err);
          this.error = true;
        })
        .finally(() => {
          this.loading = false;
        })
    }
  },

  props: [],

  mounted() {
    this.fetchData();
  },

  components: {
    Card
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
